<template>
	<div>Edit Camera Task</div>
</template>

<script>
	
	export default {
		name: 'EditCameraTask',
	}
</script>